import {useImage} from "react-image";
import LoadingSpinner from "./LoadingSpinner";
import React from "react";

const BackgroundImage = ({tag, className, srcList, spinnerSize, children, ...props}) => {
    const {src, isLoading, error} = useImage({
        srcList,
        useSuspense: false
    })
    const Tag = tag || 'div';
    return (
        <Tag {...props} className={className} style={!error ? {backgroundImage: `url("${src}")`} : {}}>

            {isLoading && (
                <div className="banner-loading">
                    <LoadingSpinner size={spinnerSize || "lg"}/>
                </div>
            )}

            {children}

        </Tag>
    )
}

export default BackgroundImage;
